import React, { useState, useEffect } from "react";
import { getAboutData, saveAboutData, uploadImage } from "./firestoreServices";

const AboutDashboard = () => {
  const [form, setForm] = useState({
    imageUrl: "",
    ar: { title: "", description: "", mission: "" },
    en: { title: "", description: "", mission: "" },
  });
  const [file, setFile] = useState(null);

  useEffect(() => {
    getAboutData().then((data) => {
      if (data) setForm(data);
    });
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    let finalUrl = form.imageUrl;
    if (file) finalUrl = await uploadImage(file);

    await saveAboutData({ ...form, imageUrl: finalUrl });
    alert("تم تحديث البيانات");
  };

  return (
    <div className="dashboard-container">
      <h2 className="page-title">إدارة قسم "من نحن"</h2>

      <div className="admin-card">
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>صورة القسم الرئيسية</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {form.imageUrl && (
                <img
                  src={form.imageUrl}
                  style={{
                    width: "100px",
                    height: "60px",
                    objectFit: "cover",
                    border: "1px solid #ccc",
                  }}
                  alt="Current"
                />
              )}
              <input type="file" onChange={(e) => setFile(e.target.files[0])} />
            </div>
          </div>

          <div className="form-grid">
            <div>
              <h4 style={{ color: "green", marginBottom: "15px" }}>
                المحتوى العربي
              </h4>
              <div className="form-group">
                <label>العنوان</label>
                <input
                  className="admin-input"
                  value={form.ar.title}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ar: { ...form.ar, title: e.target.value },
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>الوصف</label>
                <textarea
                  className="admin-textarea"
                  value={form.ar.description}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ar: { ...form.ar, description: e.target.value },
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>المهمة (Mission)</label>
                <textarea
                  className="admin-textarea"
                  value={form.ar.mission}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ar: { ...form.ar, mission: e.target.value },
                    })
                  }
                />
              </div>
            </div>

            <div>
              <h4 style={{ color: "blue", marginBottom: "15px" }}>
                English Content
              </h4>
              <div className="form-group">
                <label>Title</label>
                <input
                  className="admin-input"
                  value={form.en.title}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      en: { ...form.en, title: e.target.value },
                    })
                  }
                  dir="ltr"
                />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="admin-textarea"
                  value={form.en.description}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      en: { ...form.en, description: e.target.value },
                    })
                  }
                  dir="ltr"
                />
              </div>
              <div className="form-group">
                <label>Mission</label>
                <textarea
                  className="admin-textarea"
                  value={form.en.mission}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      en: { ...form.en, mission: e.target.value },
                    })
                  }
                  dir="ltr"
                />
              </div>
            </div>
          </div>

          <button className="btn btn-primary" style={{ marginTop: "20px" }}>
            حفظ التعديلات
          </button>
        </form>
      </div>
    </div>
  );
};
export default AboutDashboard;
